import { getDomainSlice } from 'store';
import { engineerDomain } from 'models';
import Engineer from 'models/Engineers';
import { StateSlice } from 'store/slices';

export const engineerSlice = getDomainSlice(engineerDomain);

export type EngineersSelector = StateSlice<Engineer>;
